export default {
  fzjn: "コスチュームスキル",
  fzda: "コスチュームプロフィール",
  fzpc: "コスチューム評価",
  djmb: "トップパネル",
  ydl: "閲覧数",
  dz: "いいね",
  sc: "お気に入り",
  pl: "コメント",
  fx: "シェア",
  fhsy: "ホームへ戻る",
  xzjs: "キャラ一覧",
  fzlh: "コスチューム 立ち絵",
  lhxz: "立ち絵ダウンロード",
  lh: "立ち絵",
  dt: "拡大",
  xt: "縮小",
  gscg: "ストーリーCG",
  hgddh: "絆アニメ",
  jndh: "スキル演出",
  gjswttf: "能力スキルはありません",
  qhszdb: "強化比較",
  jnql: "スキル潜在力",
  jn: "スキル効果",
  sz: {
    qh: "強化",
    xh: "消耗SP",
    lqsj: "クールタイム",
    jnfw: "範囲",
    jnxg: "スキル効果",
    hh: "ターン"
  },
  daxx: "プロフィール",
  jsyy: "セリフ",

  cqjy: "ガチャのおすすめ度",
  qdfx: "評価",
  hjfx: "環境分析",
  zrdp: "おすすめ編成",
  ckgd: "全表示",
  xppc: "推しポイント",
  jsmt: "ギャラリー",
  xct: "キャラクタービジュアル",
  jsda: "プロフィール",
  srht: "誕生祭 イラスト",
  ect: "ファンアート",
  ssxfzzsxxpc: "☆3&4コスチュームの評価は準備中です",
  xggxfdwzbpcb: "下記のテキスト版レビューをご覧ください",
  xggxfdzhpcb: "総合レビューをチェックしよう",
  ssxfzpc: "☆3&4コスチュームの評価",
  sx: "属性",
  dqsz: "ステータス",
  fctzjpb: "最適オプション",
  qhfz: "コスチューム切替",
  qhbdfz: "連携コスチューム切替",
  ky: "刻印",
  jx: "覚醒",
  zcjsy: "コレクションポ一ナス",
  fzgynlz: "コスチューム 永久ステ",
  fzbdnlz: "コスチューム 連携ステ",
  hydjsj: "最大ステータス",

  tf: "能力スキル",
  tfqhxg: "能力スキル強化",
  gjszwtf: "能力スキルはありません",
  jsxx: "キャラ情報",
  zjtj: "最強おすすめ",
  xwtb: "代用キャラ",
  jnsm: "スキル説明",
  jnfw: "範囲",
  zzjzzo: "ロード中ですよ",
  zlzskqlyrbzjj: "データが未登録です。コメントで運営に追加をリクエストできます！",
  gjsxydlhcngko: "ログイン後ご覧いただけますよ～",
  dl: "ログイン",
  gjsxsmrzhcngko: "本人確認完了後、ご覧いただけますよ～",
  smrz: "本人確認",
  ndsmxxwwcnrbfnrwfll: "登録情報が18歳未満と判定されました。年齢制限コンテンツは非表示になります。",
  tt: "クエスト",
  hjzwtjzr: "おすすめ編成はありません",
  bhhxh: "このターンのSP消費",
  chjqszd: "戦闘開始時",
  zjsysp: "SP増加/残り",
  xhsp: "SP消費",
  spbjbj: "SP変わらない",
  spsywf: "SP不足",
  spszzdtzsyjnssxdds: "SPは戦闘中にスキルを発動するために必要なポイントです",
  mhhjssfhfsojnsxyhhzsphhfbfsp: "「SP回復」スキルを発動すると、次のターンで一部のSPが回復する",
  mhhjsgjhjtsxyhhzsphhf1sp: "「攻撃/ノックバック」した後、次のターンSP+1",

  qsrxydzbmc: "装備名を入力してください",
  zyzb: "専用装備",
  zzzb: "装備作成",
  mszb: "魔獣装備",
  jbnl: "基本能力",
  xxnl: "オプション能力",
  zynl: "専用能力",
  cq: "排出",
  gl: "率",
  sj: "ランダム",
  x: "選",
  dj: "レベル",
  yb: "普通",
  gj: "高級",
  zgj: "最高級",
  cs: "伝説",
  scpzy: "コレクションポ一ナス",
  xqcl: "必要素材",
  jbnlms1: "ランダムで基本能力2のうち1つを付与<br/>各オプションの確率は等しい",
  xxnlms1:
    "レベルが3/6/9に達した時、ランダムで以下のいずれかの効果が付与される：HP（N）/ HP（%）/ 攻撃力（N）/ 攻撃力（%）/ クリ率（%）/ クリダメ（%）/ 防御力（%）/ 魔法抵抗（%）、各効果の発生確率は均等である。",
  xxnlms2:
    "レベルが3/6/9に達した時、ランダムで以下のいずれかの効果が付与される：HP（N）/ HP（%）/ 攻撃力（N）/ 魔法力（N）/ 魔法力（%）/ クリ率（%）/ クリダメ（%）/ 防御力（%）/ 魔法抵抗（%）、各効果の発生確率は均等である。",

  shengxing: "昇級",
  qh: "強化",
  jt: "ノックバック",
  gongji: "攻撃",
  wfzd: "戦闘不能",

  专用: "専用",
  制作: "作成",
  魔兽: "魔獣",

  武器: "武器",
  盔甲: "体",
  头盔: "頭",
  饰品: "装飾",
  手套: "腕",

  生命力: "HP",
  攻击力: "攻撃力",
  魔法力: "魔法力",
  致命率: "クリ率",
  致命伤害: "クリダメ",
  防御力: "防御力",
  魔法抵抗: "魔法抵抗",
  火属性伤害: "火属性ダメ",
  风属性伤害: "風属性ダメ",
  水属性伤害: "水属性ダメ",
  光属性伤害: "光属性ダメ",
  暗属性伤害: "闇属性ダメ",
  火属性抵抗: "火属性抵抗",
  风属性抵抗: "風属性抵抗",
  水属性抵抗: "水属性抵抗",
  属性抵抗: "属性抵抗"
};
